export enum TicketStatus {
	Open = 1,
	Handled = 2,
	ActionRequired = 3,
	Sleep = 4,
	Closed = 5,
	WaitForUpdate = 6,
	InDevelopment = 7,
	Deleted = 8,
	WishList = 9,
	ToTest = 10
}

export function getTicketStatusName(status: TicketStatus): any {
	if (status == TicketStatus.Open) {
		return ["open", "open"];
	}
	if (status == TicketStatus.Handled) {
		return ["handled", "afgehandeld"];
	}
	if (status == TicketStatus.ActionRequired) {
		return ["action", "Attentie klant"];
	}
	if (status == TicketStatus.Sleep) {
		return ["sleep", "slapend"];
	}
	if (status == TicketStatus.Closed) {
		return ["closed", "gesloten"];
	}
	if (status == TicketStatus.WaitForUpdate) {
		return ["wait", "Wacht update"];
	}
	if (status == TicketStatus.InDevelopment) {
		return ["development", "In ontwikkeling"];
	}
	if (status == TicketStatus.WishList) {
		return ["wishlist", "Wishlist"];
	}
	if (status == TicketStatus.Deleted) {
		return ["deleted", "Verwijderd"];
	}
	if (status == TicketStatus.ToTest) {
		return ["test", "Nog te testen"];
	}
	return ["invalid", "invalid"];
}